import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import axios from 'axios';
import ToggleIcon from './icons/ToggleIcon';
import translate from '../../commonComponents/translate';
import AddRecommendationModal from '../sessions/modal/AddRecommendationModal';
import UserProp from '../../commonComponents/propTypes/userProp';
import SessionProp from '../sessions/propTypes/sessionProp';
import ListTrainer from '../sessions/list/listItem/ListTrainer';
import CountryProp from '../../commonComponents/forms/Address/CountryProp';
import HardSkillProp from '../challenges/propTypes/hardSkillProp';
import ShowParticipantsModal from '../sessions/modal/ShowParticipantsModal';
import { useModal, useSanitize } from '../../services/customHooks';
import ParticipantFilterModal from '../sessions/modal/ParticipantFilterModal';
import MakeOrderModal from '../sessions/modal/MakeOrderModal';
import ProductProp from '../shop/propTypes/productProp';
import ShippingProviderProp from '../shop/propTypes/shippingProviderProp';
import OrganizationProp from '../../commonComponents/propTypes/organizationProp';
import CurrencyProp from '../profile/propTypes/currencyProp';
import Notifications from '../../services/notifications';
import ConfigsContext from '../../contextProviders/ConfigsContext';
import { PAYMENT_PROVIDER } from '../../commonComponents/propTypes/tenantProp';

function MoreInfoSession({
  t,
  contentId,
  title,
  startCollapsed,
  ownerId,
  session,
  hardSkills,
  languages,
  countries,
  directSellingActive,
  products,
  shippingProviders,
  organization,
  isFinished,
  currencies,
  canSeeParticipants,
}) {
  const description = useSanitize(session?.description);
  const [participantsList, setParticipantsList] = useState([]);
  const { tenant } = useContext(ConfigsContext);
  const isPaymentProviderNone =
    tenant?.settings?.paymentProviderType === PAYMENT_PROVIDER.NONE;

  const userTypeNames = {};
  Object.values(UserProp.TYPES).forEach(userType => {
    userTypeNames[userType] = t(`user_type_${userType}`);
  });

  // Make the request to the api
  const getParticipants = params =>
    new Promise((resolve, reject) => {
      axios
        .get(`/api/access-session/users/list/${session._id}`, {
          params,
          headers: {
            'Accept-Version': '1.0.0',
            'X-Gamification-API': 'Games',
          },
        })
        .then(({ data }) => {
          resolve(data.data);
        })
        .catch(err => {
          console.log(err);
          reject(err);
        });
    });

  const fetchInfo = params => {
    const requests = [getParticipants(params)];
    Promise.all(requests)
      .then(([usersStats]) => {
        if (usersStats) {
          setParticipantsList(
            usersStats.map(item => ({
              username: item.username,
              user: item._id,
              image: item.image,
            })),
          );
        }
      })
      .catch(err => {
        console.log(err);
      });
  };
  useEffect(() => {
    fetchInfo();
  }, []);

  const remainingParticipants = participantsList.length - 10;

  const [isCollapsed, setIsCollapsed] = useState(startCollapsed);
  const toggleCollapsed = () => setIsCollapsed(prev => !prev);

  useEffect(() => {
    setIsCollapsed(startCollapsed);
  }, [contentId]);

  // show recommendation modal
  const [recommendationModal, showRecommendationModal] = useModal({
    show: false,
  });
  const AddRecommendation = () => showRecommendationModal({ show: true });

  // show order modal
  const [orderModal, showOrderModal] = useModal({
    show: false,
  });
  const AddOrder = () => showOrderModal({ show: true });

  // show participants modal
  const [showParticipantModal, setShowParticipantModal] = useModal({
    show: false,
  });
  const ShowParticipants = () =>
    setShowParticipantModal({ show: true, data: { shouldSelect: true } });
  const ShowParticipantsToOwner = () =>
    setShowParticipantModal({ show: true, data: { shouldSelect: false } });

  // show add participant modal
  const [addParticipantModal, showAddParticipantModal] = useModal({
    show: false,
  });
  const AddParticipant = () => showAddParticipantModal({ show: true });

  const [participantData, setParticipantData] = useState({ user: null });
  const onSelectUserParticipant = user => {
    setShowParticipantModal({ show: false });
    setParticipantData({
      user,
    });
  };

  // Show notificiation error, if selected user isnt registered
  const handleNotActive = () => {
    Notifications.showNotificationError(
      t('error'),
      t('session.make.order.notActive'),
    );
  };
  return (
    <div className="course-more-information">
      <h2>{title}</h2>
      <div
        className={cx('course-info-extra', {
          collapsed: isCollapsed,
        })}
      >
        {
          // TODO: Hide participants list for now, for type online sessions
          session.type !== 'online' ? (
            <div className="row">
              <div className="col-lg-8 col-md-6 col-sm-12">
                <div
                  dangerouslySetInnerHTML={{
                    __html: description,
                  }}
                  style={{ marginTop: '2rem' }}
                />
              </div>
              {!!(canSeeParticipants || session.participationAreVisible) && (
                <div className="participants-container col-lg-4 col-md-6  col-sm-12">
                  <div style={{ paddingLeft: '1rem' }}>
                    <h5>{t('sessionDetails_participants')}</h5>
                    <div
                      style={{
                        paddingLeft:
                          participantsList.length > 1 ? '3rem' : '1rem',
                      }}
                      className="session_participant-icon"
                      onClick={ShowParticipants}
                    >
                      {participantsList.slice(0, 10).map(item => {
                        const avatar =
                          item.image && item.image.thumb
                            ? item.image.thumb
                            : '/images/no_user.png';
                        return (
                          <img
                            id="img-participants"
                            key={item.name}
                            src={avatar}
                            alt={item.username}
                          />
                        );
                      })}
                      {remainingParticipants >= 1 && (
                        <button
                          id="seeMore"
                          type="button"
                          onClick={ShowParticipants}
                        >
                          {`+ ${remainingParticipants}`}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div className="row">
              {session?.description && (
                <div className="col-lg-12">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: description,
                    }}
                    style={{ marginTop: '2rem' }}
                  />
                </div>
              )}
            </div>
          )
        }
      </div>
      {showParticipantModal.show && (
        <ShowParticipantsModal
          session={session}
          onClose={() => {
            setShowParticipantModal({ show: false });
          }}
          onSelectUserParticipant={onSelectUserParticipant}
          shouldSelect={showParticipantModal.data.shouldSelect}
        />
      )}
      {session.trainer && (
        <div
          className={cx('academy-course-separator-horizontal', {
            collapsed: isCollapsed,
          })}
        />
      )}
      <div
        className={cx('academy-course-features', { collapsed: isCollapsed })}
      >
        {session.trainer ? (
          <div className="row">
            <div className="col-lg-12">
              <h5>{t('sessionDetails_trainer')}</h5>
              <div className="sessionDetail-container-body">
                <ListTrainer user={session.trainer} t={t} />
              </div>
            </div>
          </div>
        ) : null}
        {ownerId === session.owner && (
          <>
            <div className={cx('academy-course-separator-horizontal')} />
            <div className="row">
              <div className="sessionDetails_participants-holder col-lg-7">
                <h5>{t('sessionDetails_participants')}</h5>
                <div
                  style={{
                    paddingLeft: participantsList.length > 1 ? '4rem' : '1rem',
                  }}
                  id="participants-holder"
                  className="sessionDetail_icon-member"
                  onClick={ShowParticipants}
                >
                  {participantsList.slice(0, 10).map(item => {
                    const avatar =
                      item.image && item.image.thumb
                        ? item.image.thumb
                        : '/images/no_user.png';
                    return (
                      <img key={item.name} src={avatar} alt={item.username} />
                    );
                  })}
                  {remainingParticipants >= 1 && (
                    <button
                      id="seeMore"
                      type="button"
                      onClick={ShowParticipantsToOwner}
                    >
                      {`+ ${remainingParticipants}`}
                    </button>
                  )}
                </div>
                <div className="sessionDetail_add-participant">
                  <span style={{ alignSelf: 'center', marginLeft: '1rem' }}>
                    {t('sessionDetails_addParticipant')}
                  </span>
                  <button
                    style={{ marginLeft: '1rem' }}
                    onClick={AddParticipant}
                    type="button"
                    disabled={isFinished}
                    className="btn m-btn--pill btn-metal navigation-button"
                  >
                    <i className="fa fa-plus" />
                  </button>
                </div>
                {addParticipantModal.show && (
                  <ParticipantFilterModal
                    session={session}
                    languages={languages}
                    hardSkills={hardSkills}
                    onClose={() => {
                      fetchInfo();
                      showAddParticipantModal({ show: false });
                    }}
                    userTypeNames={userTypeNames}
                  />
                )}
              </div>
              {participantData.user && (
                <div className="participant-selected col-lg-5">
                  <div style={{ padding: '1rem', display: 'flex' }}>
                    <img
                      className="session-image"
                      src={
                        participantData.user.image && participantData.user.image
                          ? participantData.user.image.thumb
                          : '/images/no_user.png'
                      }
                      alt="at"
                    />
                    <span style={{ alignSelf: 'center', marginLeft: '1rem' }}>
                      {participantData.user.firstName &&
                      participantData.user.lastName
                        ? `${participantData.user.firstName} ${participantData.user.lastName}`
                        : t('sessionDetails_newParticipant')}
                    </span>
                  </div>
                  <div
                    className="row justify-content-end"
                    style={{ padding: '1rem' }}
                  >
                    {directSellingActive && !isPaymentProviderNone ? (
                      <button
                        type="button"
                        onClick={
                          participantData?.user?.status === 'active'
                            ? AddOrder
                            : handleNotActive
                        }
                        className="btn m-btn--pill btn-dynamic navigation-button col-4"
                      >
                        {t('sessionDetails_makeOrder')}
                      </button>
                    ) : null}
                    <button
                      type="button"
                      onClick={AddRecommendation}
                      style={{ marginLeft: '2rem' }}
                      className="btn m-btn--pill btn-dynamic navigation-button col-6"
                    >
                      {t('sessionDetails_addRec')}
                    </button>
                  </div>
                  {recommendationModal.show && (
                    <AddRecommendationModal
                      user={participantData.user}
                      onClose={() => {
                        showRecommendationModal({ show: false });
                      }}
                    />
                  )}
                  {orderModal.show && (
                    <MakeOrderModal
                      user={participantData.user}
                      countries={countries}
                      onClose={() => {
                        showOrderModal({ show: false });
                      }}
                      products={products}
                      shippingProviders={shippingProviders}
                      organization={organization}
                      currencies={currencies}
                    />
                  )}
                </div>
              )}
            </div>
          </>
        )}
      </div>
      <span
        className={cx('academy-course-arrow-toggle', {
          collapsed: isCollapsed,
        })}
        onClick={toggleCollapsed}
      >
        <ToggleIcon />
      </span>
    </div>
  );
}

MoreInfoSession.propTypes = {
  t: PropTypes.func.isRequired,
  contentId: PropTypes.string,
  title: PropTypes.string.isRequired,
  startCollapsed: PropTypes.bool,
  ownerId: PropTypes.string.isRequired,
  session: PropTypes.shape(SessionProp.propType).isRequired,
  languages: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
  hardSkills: PropTypes.arrayOf(PropTypes.shape(HardSkillProp.propType))
    .isRequired,
  countries: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
  directSellingActive: PropTypes.bool,
  products: PropTypes.shape(ProductProp.propType).isRequired,
  shippingProviders: PropTypes.arrayOf(
    PropTypes.shape(ShippingProviderProp.propType),
  ).isRequired,
  organization: PropTypes.shape(OrganizationProp.propTypes).isRequired,
  isFinished: PropTypes.bool,
  currencies: PropTypes.arrayOf(PropTypes.shape(CurrencyProp.propType))
    .isRequired,
  canSeeParticipants: PropTypes.bool,
};

MoreInfoSession.defaultProps = {
  startCollapsed: false,
  contentId: '',
  directSellingActive: false,
  isFinished: false,
  canSeeParticipants: false,
};

export default translate(MoreInfoSession);
